import { APP_DISPLAY_NAME } from ".."

export const CALENDLY_LINK = "https://calendly.com/adam-szeptycki/tombo-demo"
export const HOME_LINK = "https://bit.ly/3xGm8ca" // tombo.ai
export const INSTALL_LINK = "https://bit.ly/3PdtmKI" // https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}

export const generateSecondFollowUpEmailBody = ({
  isRecruiterGPTSalesVacancy,
}: {
  isRecruiterGPTSalesVacancy: boolean
}) => {
  // this is vacancy for RGPT sales
  if (isRecruiterGPTSalesVacancy) {
    return `
    <div dir="ltr">
    My AI recruiter robot is following up on my previous email for me. Just like it can do for you.<br>
    <br>
    Install&nbsp;<a href="${HOME_LINK}" target="_blank">${APP_DISPLAY_NAME}</a>&nbsp;for free, or book a 1:1 with me <a href="${CALENDLY_LINK}" target="_blank">here</a> so I can show you how it saves me 2-3 hours a day.<br clear="all">
    </div>
    <div>
      <br>
      <a style="color:#999999" href="${INSTALL_LINK}" target="_blank">${APP_DISPLAY_NAME} rated 4.9 of 5 stars on Google Store</a>
    </div>
    `
  }
  return `<div>Just bumping this up in your inbox</div>`
}

export const generateThirdFollowUpEmailBody = ({
  vacancy,
  isRecruiterGPTVacancy,
  candidate,
}: {
  isRecruiterGPTVacancy: boolean
  vacancy?: { vertical?: string | null; jobTitle?: string | null } | null
  candidate?: { firstName?: string | null }
}) => {
  if (vacancy?.vertical === "CONSTRUCTION" && isRecruiterGPTVacancy) {
    const jbConstructionFollowup = `
    <div >
    <div>I understand you're not looking for new job opportunities right now but I'd like to <b>offer you a $500 VISA gift card</b> (sent via Amazon) if you intro us to any friends we hire.&nbsp;</div><br>
    <div><u>CURRENT OPENINGS</u></div>
    <div>
        <b>Estimator:</b> Detroit MI or Long Island NY or Anaheim CA.<br>
        <b>Senior Estimator</b>: Pittsburgh PA<br>
        <b>Engineering Manager:</b> Cincinnati OH or Louisville KY or Indianapolis&nbsp;IN or Charleston WV or Nashville TN&nbsp;<br>
        <b>Senior Electrical Estimator:</b> Cincinnati OH<br>
        <b>Project Manager:</b>Dallas TX<br>
        <b>VP of Healthcare Construction:</b> Austin TX or Dallas TX<br>
        <b>VP of Industrial Construction:</b> Dallas TX or Houston TX<br>
        <b>Professional Engineer:</b> Boca Raton FL or Port St. Lucie FL<br>
        <b>Land Surveyor:</b> Boca Raton FL or Port St. Lucie FL<br>
        <b>Construction Project Manager:</b> Austin, TX<br>
        <b>Oil &amp; Gas Landman:</b> Austin, TX<br>

        <div>Know anyone you can recommend${candidate ? `, ${candidate?.firstName}` : ""}?
    </div>
  </div>
  `.trim()
    return jbConstructionFollowup
  }

  const firstLine = vacancy?.jobTitle
    ? `This is my last attempt to reach you about the job offer for a {vacancy.jobTitle}`
    : `This is my last attempt to reach you about this job offer.`
  const defaultThirdTouch = `
  <div>
    ${firstLine}
    <br/><br/>
    Just reply with one of these numbers 
    <ol>
    <li>(want to learn more - let's chat)</li>
    <li>(not interested now but follow up in 6 months)</li>
    <li>(I'm never changing jobs, don't contact me again)</li>
    </ol>
</div>`

  return defaultThirdTouch
}
